
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';

    class Editapplyrejection {
        id: number;
        expressCompany: string;
        warehouseInfoId: number;
        shipment: string;
        reMark: string;
        orderType: number = 0;
        whetherAbroad?: boolean;
        storeId: number = 0;
    }
    @Component
    export default class CreateapplyrejectionModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        applyrejection: Editapplyrejection = new Editapplyrejection();
        warehouseCityId: number = 0;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        warehouseOrderType = Enums.WarehouseOrderType;
        storeaddressList: Array<storeaddressInfo> = [];
        whetherAbroadList = Enums.WhetherAbroadStatus;
        isDisplay: string = '';
        isReadOnly = false;
        isDisplays: boolean = false;
        isDisplayx: boolean = true;
        created() {
            this.getCity();
        }
        submit() {
            this.save();
        }
        save() {
            //this.applyrejection.handleType = Enums.HandleStatus.filter(function (item) { return item.value == 2 })[0].value;
            (this.$refs.applyrejectionCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    await this.$store.dispatch({
                        type: 'expressrejectioninfo/createRejection',
                        data: this.applyrejection
                    });
                    (this.$refs.applyrejectionCreateForm as any).resetFields();

                    this.getCity();

                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            //a.id = null;
            //a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            if (this.storeaddressList.length > 0) {
                this.applyrejection.storeId = this.storeaddressList[0].id;
            }
            //this.storeaddressList.push(a);

        }
        changestatus(a: any) {

            if (a == true) {
                this.getData();
                this.isDisplays = true;
                this.isDisplayx = false;
            }
            else {
                this.isDisplays = false;
                this.isDisplayx = true;
                
            }
        }
        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.applyrejection.warehouseInfoId = this.warehouseInfoList[0].id;
            }
        }
        async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
            }
        }
        cancel() {
            (this.$refs.applyrejectionCreateForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
        applyrejectionRule = {
            warehouseInfoId: [
                { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
            ],
            shipment: [
                { required: true, max: 30, message: '快递单号不能为空，且长度必须小于30', trigger: 'blur' }
            ],
            expressCompany: [
                { required: true, max: 30, message: '快递公司不能为空', trigger: 'blur' }
            ],
            reMark: [
                { max: 500, message: '长度不能大于500', trigger: 'blur' }
            ]
        };

    }
